export default {
  // 依使用者語系取得指定功能文案
  getFunctionWording(setting, name) {
    const func = this.getFunction(setting, name);
    if (!func) return '';

    return this.getWording(func.wording, setting.defaultLanguage);
  },
  // 取得功能設定
  getFunction(setting, name) {
    return setting.function.find((x) => x.name === name);
  },
  // 依使用者語系取得文案
  getWording(wordings, defaultLang) {
    const lang = (navigator.language || navigator.userLanguage || defaultLang).toLowerCase();

    let target = wordings.find((x) => x.language === lang);
    if (!target) target = wordings.find((x) => x.language.split('-')[0] === lang.split('-')[0]);
    if (!target) target = wordings.find((x) => x.language === defaultLang);
    if (!target) return '';

    return target.value;
  },
};
